import treatmentRoutes from './treatment.routes';

import treatmentSaveController from './controllers/treatment.save.controller';
import treatmentFormController from './controllers/treatment.form.controller';
import treatmentListController from './controllers/treatment.list.controller';
import treatmentsSelectController from './controllers/treatments.select.controller';
import treatmentSingleSelectController from './controllers/treatment.single.select.controller';

import treatmentListComponent from './components/treatment.list.component';
import treatmentFormComponent from './components/treatment.form.component';
import treatmentSaveComponent from './components/treatment.save.component';
import treatmentsSelectComponent from './components/treatments.select.component';
import treatmentSingleSelectComponent from './components/treatment.single.select.component';

import treatmentsService from './services/treatments.service';

let treatmentModule = angular.module('spabooker.treatment', [ 'spabooker.base' ])
  .config(treatmentRoutes)

  .controller('treatmentSaveController', treatmentSaveController)
  .controller('treatmentFormController', treatmentFormController)
  .controller('treatmentListController', treatmentListController)
  .controller('treatmentsSelectController', treatmentsSelectController)
  .controller('treatmentSingleSelectController', treatmentSingleSelectController)

  .component('treatmentList', treatmentListComponent)
  .component('treatmentForm', treatmentFormComponent)
  .component('treatmentSave', treatmentSaveComponent)
  .component('treatmentsSelect', treatmentsSelectComponent)
  .component('treatmentSingleSelect', treatmentSingleSelectComponent)

  .factory('treatmentsService', treatmentsService)
;

export default treatmentModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/index.js